<template lang="pug">
UpsertBookingPanel(title="Non scheduled products" data-test-id="non-scheduled-products-panel")
  template(v-slot:heading-action="")
    BriqButton(small @click="addNonScheduledProduct" data-test-id="add-non-scheduled-product-button") Add product
  template(v-slot:body="")
    NonScheduledProductsTable(
      v-if="nonScheduledProducts && nonScheduledProducts.length > 0"
      :nonScheduledProducts="nonScheduledProducts" 
      :nonScheduledProductOptions="nonScheduledProductOptions" 
      :classifications="classifications"
      @deleteBookingProduct="p => $emit('delete', p)"
      @switchNonScheduledProduct="x => $emit('switchNonScheduledProduct', x)"
      )
    i(v-else style="opacity: 0.5") This booking does not contain any non scheduled products
</template>

<script>
import UpsertBookingPanel from '@v/bookings/edit/components/UpsertBookingPanel.vue'
import NonScheduledProductsTable from './PanelNonScheduledProducts/NonScheduledProductsTable.vue'

export default {
  name: 'PanelNonScheduledProducts',
  components: { UpsertBookingPanel, NonScheduledProductsTable },
  props: {
    booking: { type: Object, required: true },
    products: { type: Array, required: true },
    classifications: Array,
  },
  computed: {
    nonScheduledProducts() {
      return this.booking.BookingProducts.filter(p => !p.NeedsToBeScheduled)
    },
    nonScheduledProductOptions() {
      return this.products.filter(p => !p.NeedsToBeScheduled)
    },
  },
  methods: {
    addNonScheduledProduct() {
      const quantity = this.booking.NumberOfPersons || 1
      this.booking.BookingProducts.push({
        NameInternal: null,
        ProductKey: null,
        NeedsToBeScheduled: false,
        ProductQuantity: quantity,
        QuantitiesPerClassification: [],
        Key: null,
        isSegmentless: true,
        tempId: new Date().getTime(),
      })
    },
  },
}
</script>
